import { Card } from "@/components/ui/Card";
import { InlineArrow } from "@/components/icons/InlineArrow";

export function TemplatesCard({ count }: { count: number }) {
  return (
    <Card
      title="Templates"
      subtitle="Manage reusable mapping templates outside the main navigation."
    >
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-[13px] font-medium text-zinc-900 dark:text-zinc-100">
            {count} saved template{count === 1 ? "" : "s"}
          </p>
          <p className="mt-0.5 text-[11px] text-zinc-500 dark:text-zinc-400">
            Review, group, and edit the templates used by workbook sheets.
          </p>
        </div>
        <a
          href="/profiles"
          className="inline-flex w-fit rounded-lg border border-zinc-300 dark:border-border bg-white dark:bg-surface px-3 py-1.5 text-[12px] font-medium text-zinc-800 dark:text-zinc-200 transition hover:bg-zinc-50 dark:hover:bg-surface-2"
        >
          Manage mapping templates <InlineArrow />
        </a>
      </div>
    </Card>
  );
}
